import { ElectionDayData } from './ElectionDayWidgets'
import { ContentModels, PollieRaterMessages } from './PollieRater'

export type FeatureCategory = 'pollie-rater' | 'election-day-widgets'

export interface FeatureCategoryConfig {
    featureCategory: FeatureCategory
    objectPath: string // path to the object store inside S3
    cacheAge: number // Cache of object store.
}

export const isElectionDayData = (
    message: ElectionDayData | PollieRaterMessages,
): message is ElectionDayData => 'lastUpdated' in message

export interface ContentfulMessage {
    metadata: {
        tags: Array<string>
    }
    sys: SystemData
    fields?: Record<string, FieldType>
}

export interface PaginatedContentfulMessage<T> {
    sys: {
        type: 'Array'
    }
    total: number
    skip: number
    limit: number
    items: Array<T>
}

export interface FieldType {
    // I'm not sure if this is a good idea
    'en-US': FieldValue
}

export type FieldValue = LinkType | string | number | FileType | boolean

export interface FileType {
    url: string
    details: FileDetails
    fileName: string
    contentType: string
}

export interface FileDetails {
    size: number
    image: {
        width: number
        height: number
    }
}

export interface LinkType {
    sys: {
        type: 'Link'
        linkType: ContentTypes // This refers to the type of the object that the link denotes
        id: ContentModels
    }
}

export interface SystemData {
    type: ContentTypes
    linkType?: string
    id: string
    space: LinkType
    environment: LinkType
    contentType?: LinkType
    publishedCounter?: number
    publishedVersion?: number
    version?: number
    firstPublishedAt?: string
    createdAt: string
    createdBy: LinkType
    publishedAt?: string
    publishedBy?: LinkType
    updatedAt: string
    updatedBy: LinkType
    revision: number
}

export type ContentTypes =
    | 'ContentType'
    | 'Asset'
    | 'Entry'
    | 'Space'
    | 'Environment'
    | 'User'
    | 'DeletedAsset'
    | 'DeletedEntry'
    | 'Error'
